import i18n from '@/utils/i18n';
import React, { useState } from 'react';
import { ActionSheet } from '@/components/action-sheet';
import { FONTS, TYPOGRAPHY } from '@/styles';
import { RadioButtonGroup } from '@/components/radio-button-group';
import { StyleSheet } from 'react-native';

export enum SelectedMatchingAccountType {
  EMAIL = 'email',
  PHONE = 'phone',
}

interface Props {
  contactInfo: { loginEmail: string; phoneNumber: string };
  onClose: (selectedValue?: SelectedMatchingAccountType) => void;
}

export const MatchingAccountActionSheet: React.FC<Props> = ({
  contactInfo,
  onClose,
}) => {
  const [selectedValue, setSelectedValue] =
    useState<SelectedMatchingAccountType>();
  const options = [
    {
      label: i18n.t('invite_employee.matching_account.account_with', {
        contactInfo: contactInfo.phoneNumber,
      }),
      value: SelectedMatchingAccountType.PHONE,
    },
    {
      label: i18n.t('invite_employee.matching_account.account_with', {
        contactInfo: contactInfo.loginEmail,
      }),
      value: SelectedMatchingAccountType.EMAIL,
    },
  ];

  return (
    <ActionSheet
      actions={[i18n.t('invite_employee')]}
      disabledIndices={selectedValue ? [] : [0]}
      isVisible
      message={
        <RadioButtonGroup
          baseStyle={styles.radioButtonGroup}
          onChange={(value) => setSelectedValue(value)}
          options={options}
          rowStyle={styles.radioButtonRow}
          selectedValue={selectedValue}
          textStyle={styles.radioButtonGroupText}
          title={i18n.t('invite_employee.matching_account.subtitle')}
          titleStyle={[TYPOGRAPHY.p, styles.radioButtonGroupTitle]}
        />
      }
      onAction={() => {
        if (selectedValue) {
          onClose(selectedValue);
        }
      }}
      onBackdropPress={() => onClose()}
      onClose={() => onClose()}
      title={i18n.t('invite_employee.matching_account.title')}
      titleStyle={styles.header}
    />
  );
};

const styles = StyleSheet.create({
  header: {
    marginBottom: 0,
    textAlign: 'left',
  },
  radioButtonGroup: {
    borderTopWidth: 0,
    paddingBottom: 24,
    paddingTop: 8,
  },
  radioButtonGroupText: {
    ...FONTS.primarySemiBold,
    fontSize: 16,
    lineHeight: 19,
  },
  radioButtonGroupTitle: {
    lineHeight: 22,
    marginBottom: 8,
    textTransform: 'none',
  },
  radioButtonRow: {
    marginVertical: 0,
    paddingVertical: 8,
  },
});
